import moment from "moment";
import { useQueryClient } from 'react-query';
import styled from 'styled-components';
import theme from '../../styles/theme';
import Button from '../../components/common/Button';
import { useRef, useState } from 'react';
import { adminLogin } from '../../interface/auth';

const MainWrap = styled.div`
    width: 100%;
    height: 100vh;
    background: ${theme.color.white[100]};
    display:flex;
    align-items:center;
    justify-content: center;
    flex-direction: column;
`;

const LoginCard = styled.div`
    width: calc(30vw - 2rem);
    height: calc(70vh - 2rem);
    min-width: 300px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    background: ${theme.color.primary.main};
    border-radius: 16px;
    border: 0.5px solid ${theme.color.black[10]};
    padding: 1rem;
    transition: all 400ms ease-in-out, transform 400ms ease-in-out;
    h1 {
        margin: 0;
        color: ${theme.color.black[80]};
        font-weight: 800;
    }
    &:hover {
        // background: ${theme.color.primary.pupple};
        box-shadow: ${theme.color.shadow};
    }
    span {
        font-size: 0.8rem;
        color: ${theme.color.secondary.red};
    }
`;

const StyledInputBox = styled.input`
    outline: 0;
    border: 1.4px solid ${theme.color.black[10]};
    background: ${theme.color.white[100]};
    // border-image-source: linear-gradient(91.1deg, #fc6741 11.83%, #ed5255 88.83%) 100% / 40px;
    padding: 0px 12px;
    // margin: 6px;
    width: calc(100% - 26.8px); // padding 12 * 2 + margin 6 * 2 + border 1.4 * 2
    height: 2.5rem;
    border-radius: 8px;
    // font-size: 18px;
    // line-height 24px;
    &:-webkit-autofill {
        transition: background-color 5000s;
        background: ${theme.color.white[100]} !important;
    }
    &:-webkit-autofill:active {
        transition: background-color 5000s;
        background: ${theme.color.white[100]} !important;
    }
    &:-webkit-autofill:hover {
        transition: background-color 5000s;
        background: ${theme.color.white[100]} !important;
    }
    &:-webkit-autofill:focus {
        transition: background-color 5000s;
        background: ${theme.color.white[100]} !important;
    }
    // &:autofill {
    //     background-color: ${theme.color.white[80]};

    // }
    // &:-webkit-autofill {
    //     background-color: ${theme.color.white[80]};
    // }
`
const AdminLogin = () => {

    const queryClient = useQueryClient();

    const idRef = useRef(null);
    const pwdRef = useRef(null);

    const [user_no, setUser_no] = useState();
    const [pwd, setPwd] = useState();

    const [comment, setComment] = useState();

    const handleClick = () => {
        
        if(user_no && pwd){
            adminLogin({user_no,pwd})
                .then((res)=>{
                    if(res && res.data.length>0){
                        const conv = res.data[0]
                        conv.ex_date = moment().add(1,'day').format("yyyyMMDDHHmmss")
                        queryClient.setQueryData('ADMIN_USER_INFO',conv);
                        localStorage.setItem('ADMIN_USER_INFO',JSON.stringify(conv))
                    }else{
                        setComment('아이디/비밀번호를 확인해주세요')
                    }
                })
                .catch((err)=>{
                    console.log(err)
                    setComment('로그인에 실패 하였습니다. 잠시후 시도해주시기 바랍니다. 이 상황이 지속되면 문의 바랍니다.')
                });
        }else{
            setComment('아이디/비밀번호를 확인해주세요')
        }
    }

    const handleKeydown = (e) => {
        if(e.keyCode === 13) {
            if(e.target.tabIndex === 1){
                pwdRef.current.focus();
            }else if(e.keyCode === 13){
                handleClick();
            }
        }

    }

    return (
        <MainWrap>
            <LoginCard>
                <h1>TAMS</h1>
                <div style={{width:'85%',height:'7rem',display:'flex',justifyContent:'space-between',flexDirection:'column'}}>
                    <div><StyledInputBox ref={idRef} type='text' tabIndex={1} onChange={(e)=>setUser_no(e.target.value)} placeholder={`아이디`} onKeyDown={handleKeydown}/></div>
                    <div><StyledInputBox ref={pwdRef} type='password' tabIndex={2} onChange={(e)=>setPwd(e.target.value)} placeholder={`비밀번호`} onKeyDown={handleKeydown}/></div>
                    <div style={{height:'1rem',textAlign:'center'}}>
                        {comment && 
                            <span>{comment}</span>
                        }
                    </div>
                </div>
                <div style={{width:'85%'}}>
                    <Button onClick={handleClick}>Login<img src={`/images/ic_login.svg`} alt='' /></Button>
                </div>
                <img src={`/images/logo_nb.png`} style={{width: '6rem',margin:'1rem 0rem'}}/>
            </LoginCard>
        </MainWrap>
    )
}

export default AdminLogin;